module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-07 at 19.23.01.35182ae6.jpeg";